import { FC } from 'react';
import {
  Autocomplete,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import {
  FirmOption,
  OrgUserFirmAccessType,
} from 'hooks/data/organisation/useOrgUserFirmAccess';

type Props = {
  firmAccess: OrgUserFirmAccessType;
  selectedFirms: Array<FirmOption>;
  eisFirms: Array<FirmOption>;
  onFirmAccessChange: (value: OrgUserFirmAccessType) => void;
  onSelectedFirmsChange: (firms: Array<FirmOption>) => void;
};

const OrgUserFirmAccessSelector: FC<Props> = ({
  firmAccess,
  selectedFirms,
  eisFirms,
  onFirmAccessChange,
  onSelectedFirmsChange,
}) => (
  <>
    <RadioGroup
      value={firmAccess}
      onChange={(e) =>
        onFirmAccessChange(e.target.value as OrgUserFirmAccessType)
      }
    >
      <FormControlLabel
        value={OrgUserFirmAccessType.All}
        control={<Radio />}
        label="All firms access"
      />
      <FormControlLabel
        value={OrgUserFirmAccessType.Specific}
        control={<Radio />}
        label="Specific firms only"
      />
    </RadioGroup>
    {firmAccess === OrgUserFirmAccessType.Specific && (
      <Autocomplete
        multiple
        options={eisFirms}
        getOptionLabel={(option) => option.firmName}
        getOptionKey={(option) => option._id}
        filterSelectedOptions
        value={selectedFirms}
        onChange={(_, newValue) => onSelectedFirmsChange(newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder="Select firms (leave empty for no access)"
          />
        )}
      />
    )}
  </>
);

export default OrgUserFirmAccessSelector;
